import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import _module from '@/store/base/module'

const module = {
  state: {
    message: ''
  },

  getters: {
    getMessage (state) {
      return state.message
    }
  },

  mutations: {
    SET_MESSAGE (state, payload) {
      state.message = payload
    }
  },

  actions: {
    sendNotification: ({ state }) => {
      return ApiUtils.postData({ data: [{ api: 'E0009DemoBroadcastingService.sendNotification', input: state.message }] })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
